import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import '../styles/article.css'

class Article extends Component {
  render () {
    const article = (
      <article className={'article' + ((this.props.externalLink === true) ? ' external-link' : '')}>
        <div className='article-image' style={{backgroundImage: 'url(' + this.props.image + ')'}} />
        <div className='hexBackground' />
        <div className='hexBackground' />
        <div className='detail'>
          <h3 dangerouslySetInnerHTML={{__html: this.props.title}} />
          <p dangerouslySetInnerHTML={{__html: this.props.subtext}} />
        </div>
      </article>
    )

    if (this.props.active) {
      return (
        <Link to={this.props.url} onClick={this.props.onClick}>
          {article}
        </Link>
      )
    }
    return article
  }
}

Article.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  externalLink: PropTypes.bool
}

export default Article



// WEBPACK FOOTER //
// ./src/components/Article.js